import React from 'react';
import {
  Box,
  TextField,
  InputLabel,
  makeStyles,
  InputBaseComponentProps
} from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { colorSet, clsx } from '@components/Provider';

interface ProfileUpdateInputProps {
  name: string;
  label: string;
  placeholder: string;
  type?: 'text' | 'number';
  subLabel?: React.ReactNode;
  inputProps?: InputBaseComponentProps;
  error?: boolean;
  helperText?: string;
  className?: string;
}

const ProfileUpdateInput: React.FC<ProfileUpdateInputProps> = ({
  name,
  label,
  placeholder,
  type,
  subLabel,
  inputProps,
  error,
  helperText,
  className
}) => {
  const { container, labelBox, inputStyle } = useStyles();

  return (
    <Box className={clsx([className, container])}>
      <InputLabel htmlFor={name} className={labelBox}>
        <CustomizedTypography
          variant="body1"
          fontWeight="700"
          color="textPrimary"
        >
          {label}
        </CustomizedTypography>
        {subLabel}
      </InputLabel>
      <TextField
        name={name}
        className={inputStyle}
        inputProps={inputProps}
        variant="outlined"
        size="small"
        id={name}
        placeholder={placeholder}
        type={type}
        fullWidth
        error={error}
        helperText={helperText}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  labelBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .gray600': {
      color: colorSet.gray600
    }
  },
  inputStyle: {
    '& input': {
      padding: '12px 12px 10px'
    },
    '& input:disabled': {
      borderRadius: '4px',
      backgroundColor: 'rgb(248,248, 253)',
      color: 'rgba(0, 87, 178, 0.5)'
    },
    '& input::placeholder': {
      ...theme.typography.body2,
      color: colorSet.gray500
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${colorSet.gray500}`
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${colorSet.gray500}`
    }
  }
}));

export default ProfileUpdateInput;
